import axiosClient from './axiosClient';

export interface MilestoneItem {
  title: string;
  description: string;
  targetDate: string;
  priority: 'HIGH' | 'MEDIUM' | 'LOW';
}

export interface KickoffAnalysisDto {
  id: string;
  opportunityId: string;
  status: 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';
  strategySummary?: string;
  kickoffAgenda?: string[];
  milestones?: MilestoneItem[];
  resourceRecommendations?: string[];
  riskMitigation?: string[];
  keyDeliverables?: string[];
  timelineWeeks?: number;
  readinessScore?: number;
  detailedPlan?: string;
  errorMessage?: string;
  modelUsed?: string;
  tokensUsed?: number;
  triggeredByName?: string;
  startedAt?: string;
  completedAt?: string;
  createdAt?: string;
}

export const kickoffAnalysisApi = {
  trigger: (opportunityId: string) =>
    axiosClient.post<KickoffAnalysisDto>(`/opportunities/${opportunityId}/kickoff-analysis`),

  getLatest: (opportunityId: string) =>
    axiosClient.get<KickoffAnalysisDto>(`/opportunities/${opportunityId}/kickoff-analysis/latest`),

  getAll: (opportunityId: string) =>
    axiosClient.get<KickoffAnalysisDto[]>(`/opportunities/${opportunityId}/kickoff-analysis/all`),
};
